import cn from "classnames";
import React from "react";
import SecondaryButton from "web/react/components/buttons/secondary-button/secondary-button";
import { gettext } from "web/script/modules/django-i18n";

export interface SeeSimilarInStockButton {
    className?: string;
    viewMoreUrl?: string;
}

function SeeSimilarInStockButton({
    className,
    viewMoreUrl,
}: SeeSimilarInStockButton): React.ReactElement {
    return (
        <div className={cn(className)}>
            <SecondaryButton href={viewMoreUrl} fullWidth>
                {gettext("feed.product_card.see_similar_in_stock.link")}
            </SecondaryButton>
        </div>
    );
}

export default SeeSimilarInStockButton;
